<template>
  <div class="row student-doc">
    <div class="col">
      <div class="row mb-3">
        <div class="col">
          <div class="flex-between flex-align-center">
            <div class="flex">
              <el-button type="primary" size="small" @click="exportTable">导出表格</el-button>
              <el-select
                v-if="filterDimension == 1"
                class="group-condition"
                v-model="group"
                @change="handleGroup"
              >
                <el-option value="0" label="全部小组"></el-option>
                <el-option
                  v-for="item in groupOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                v-if="filterDimension == 2"
                class="group-condition"
                v-model="course"
                @change="handleCourse"
              >
                <el-option value="0" label="全部选课"></el-option>
                <el-option
                  v-for="item in courseOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="data-range">统计范围：{{ countArea }}</div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <el-table
            id="student-doc-table"
            class="mb-3"
            :data="studentTableData"
            row-key="id"
            default-expand-all
            stripe=""
            show-summary
            :summary-method="getAvg"
          >
            <el-table-column prop="username" label="学号"></el-table-column>
            <el-table-column prop="firstname" label="姓名">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.user_id != -1"
                  class="operative"
                  @click="viewStudent(scope.row)"
                >
                  {{ scope.row.firstname }}
                </el-link>
                <span v-else>{{ scope.row.firstname }}</span>
              </template>
            </el-table-column>
            <el-table-column width="300" prop="group" label="所在小组"></el-table-column>
            <el-table-column prop="spend_time" label="学习时长(分)"></el-table-column>
            <el-table-column prop="progress" label="学习进度(%)"></el-table-column>
            <el-table-column prop="access_day" label="课程浏览天数"></el-table-column>
            <el-table-column prop="access_num" label="课程浏览数"></el-table-column>
            <el-table-column prop="activity" label="参与活动数"></el-table-column>
            <el-table-column prop="resource" label="浏览资源数"></el-table-column>
            <el-table-column prop="assign" label="参与作业数"></el-table-column>
            <el-table-column prop="forum" label="参与讨论数"></el-table-column>
            <el-table-column prop="quiz" label="参与测验数"></el-table-column>
            <el-table-column prop="formatGrade" label="课程成绩"></el-table-column>
          </el-table>
          <Pagination
            :totalSize="totalSize"
            :currentPage="currentPage"
            @setPageSizesVal="getPageSizesVal"
            @setCurPageVal="getCurPageVal"
          ></Pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination.vue'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      studentData: [],
      studentTableData: [],
      // 小组选项
      group: '0',
      groupOption: [],
      // 选课选项
      course: '0',
      courseOption: [],
      // 页码数据
      totalSize: null,
      currentPage: 1,
      pageSizesVal: 10,
    }
  },
  mounted() {
    this.getStudentDocApi()
    this.getCourseGroupApi()
    this.getCourseJoinTypeApi()
  },
  computed: {
    // 统计范围
    countArea() {
      return (
        this.$store.state.course.courseInfo.statistics_start_time.split('-').join('.') +
        '-' +
        this.$store.state.course.courseInfo.statistics_end_time.split('-').join('.')
      )
    },
    // 筛选维度
    filterDimension() {
      return this.$store.state.course.courseInfo.search_setting
    },
    // table统计行文本
    groupName() {
      for (let i of this.groupOption)
        if (i.id == +this.group) {
          return i.name + '(本页)'
        }
      return '全部小组(本页)'
    },
    selectCourseName() {
      for (let i of this.courseOption)
        if (i.id == +this.course) {
          return i.name + '(本页)'
        }
      return '全部选课(本页)'
    },
  },
  methods: {
    // 获取当前页的数据平均值
    getAvg(param) {
      const { data } = param
      let perColumnAvg = {
        username: '平均',
        firstname: '-',
        group: this.filterDimension == 1 ? this.groupName : this.selectCourseName,
        spend_time: 0,
        progress: 0,
        access_day: 0,
        access_num: 0,
        activity: 0,
        resource: 0,
        assign: 0,
        forum: 0,
        quiz: 0,
        formatGrade: 0,
      }
      if (data.length > 0) {
        for (let i of data) {
          perColumnAvg.spend_time += +i.spend_time
          perColumnAvg.progress += +i.progress
          perColumnAvg.access_day += +i.access_day
          perColumnAvg.access_num += +i.access_num
          perColumnAvg.activity += +i.activity
          perColumnAvg.resource += +i.resource
          perColumnAvg.assign += +i.assign
          perColumnAvg.forum += +i.forum
          perColumnAvg.quiz += +i.quiz
          perColumnAvg.formatGrade += +i.grade
        }
        perColumnAvg.spend_time = (perColumnAvg.spend_time / data.length).toFixed(2)
        perColumnAvg.progress = (perColumnAvg.progress / data.length).toFixed(2)
        perColumnAvg.access_day = (perColumnAvg.access_day / data.length).toFixed(2)
        perColumnAvg.access_num = (perColumnAvg.access_num / data.length).toFixed(2)
        perColumnAvg.activity = (perColumnAvg.activity / data.length).toFixed(2)
        perColumnAvg.resource = (perColumnAvg.resource / data.length).toFixed(2)
        perColumnAvg.assign = (perColumnAvg.assign / data.length).toFixed(2)
        perColumnAvg.forum = (perColumnAvg.forum / data.length).toFixed(2)
        perColumnAvg.quiz = (perColumnAvg.quiz / data.length).toFixed(2)
        perColumnAvg.formatGrade = (perColumnAvg.formatGrade / data.length).toFixed(2)
      }
      let avgData = []
      for (let key in perColumnAvg) {
        avgData.push(perColumnAvg[key])
      }
      return avgData
    },
    // 获取课程小组
    async getCourseGroupApi() {
      await this.$store
        .dispatch('course/getCourseGroup', {
          course_id: +this.$route.query.courseId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.groupOption = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取选课方式
    async getCourseJoinTypeApi() {
      await this.$store
        .dispatch('course/getCourseJoinType', {
          course_id: +this.$route.query.courseId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.courseOption = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取学生档案列表
    async getStudentDocApi(type = '') {
      await this.$store
        .dispatch('course/getStudentDoc', {
          course_id: Number(this.$route.query.courseId),
          group: +this.group || 0,
          method: +this.course || 0,
          keyword: '',
          page: this.currentPage,
          pagesize: this.pageSizesVal,
          print: type === 'download' ? 1 : 0,
          responseType: type === 'download' ? 'blob' : '',
        })
        .then(res => {
          if (type === 'download') {
            const link = document.createElement('a') // 创建a标签
            let blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
            }) //文件流处理
            link.style.display = 'none' //去除a标签的样式
            // 设置连接
            link.href = URL.createObjectURL(blob)
            link.download = '学员档案'
            document.body.appendChild(link)
            //模拟点击事件
            link.click()
            //移除创建的a标签
            window.URL.revokeObjectURL(link.href)
            document.body.removeChild(link)
          } else if (res.code === 1) {
            console.log('res:', res)
            this.studentData = res.data.list
            this.studentTableData = this.studentData.map(item => {
              let formatGrade = Number.parseFloat(item.grade).toFixed(2)
              return {
                formatGrade: formatGrade,
                ...item,
              }
            })

            this.totalSize = res.data.paging.records
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 筛选处理事件
    handleGroup(value) {
      console.log('value:', value)
      this.getStudentDocApi()
    },
    handleCourse(value) {
      console.log('value:', value)
      this.getStudentDocApi()
    },
    // 查看学生档案跳转
    viewStudent(row) {
      this.$router.push({
        path: '/courseDetail/studentDoc/studentDetail',
        query: {
          courseId: this.$route.query.courseId,
          userId: row.user_id,
        },
      })
    },
    // 页码操作
    getPageSizesVal(pageSizesVal) {
      this.pageSizesVal = pageSizesVal
      this.getStudentDocApi()
    },
    getCurPageVal(curPageVal) {
      this.currentPage = curPageVal
      this.getStudentDocApi()
    },
    // 导出表格
    exportTable() {
      this.getStudentDocApi('download')
    },
  },
}
</script>
<style lang="scss" scoped>
.student-doc {
  ::v-deep .el-table {
    thead {
      th.el-table__cell {
        background-color: #f5f7fa;
      }
    }
    .cell {
      color: #6c757d;
    }
  }
  .data-range {
    font-size: 14px;
    color: #6c757d;
    line-height: 19px;
  }
  .group-condition {
    margin-left: 12px;
  }
}
.operative {
  color: #409eff;
  margin-right: 1rem;
  cursor: pointer;
}
</style>
